import React, { useState } from "react";
import { X } from "lucide-react";
import { BASE_URL } from "../../../../utils/constant";

const NewCommentModal = ({ onClose, delivery, onSuccess }) => {
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const accessToken = localStorage.getItem("access");
      const response = await fetch(`${BASE_URL}/inventory/create-comment/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          delivery: delivery?.id,
          comment: comment,
        }),
      });

      const data = await response.json();
      if (data.status) {
        onSuccess?.();
        onClose();
      } else {
        setError(data.message || "Failed to create comment");
      }
    } catch (err) {
      setError("Failed to create comment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl animate-in fade-in zoom-in-95 duration-200">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-xl font-bold text-slate-900">Add Update</h2>
          <p className="text-xs font-medium text-slate-500 mt-0.5">Share a remark about this delivery</p>
        </div>
        <button 
          onClick={onClose} 
          className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-xl transition-all"
        >
          <X size={20} />
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">
            Your Comment
          </label>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            className="w-full px-4 py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-sm-primary/20 focus:border-sm-primary outline-none transition-all text-sm font-medium min-h-[120px] resize-none"
            placeholder="Type your update here..."
            required
          />
          {error && <p className="text-xs text-red-500 mt-2 font-medium">{error}</p>}
        </div>

        <button
          type="submit"
          disabled={loading || !comment.trim()}
          className="w-full bg-sm-primary text-white py-3 rounded-xl font-bold text-sm shadow-lg shadow-sm-primary/20 hover:brightness-110 active:scale-95 transition-all disabled:opacity-50 disabled:pointer-events-none"
        >
          {loading ? "SAVING..." : "SAVE UPDATE"}
        </button>
      </form>
    </div>
  );
};

// Helper function to delete comment
const deleteComment = async (commentId) => {
  try {
    const accessToken = localStorage.getItem("access");
    const response = await fetch(
      `${BASE_URL}/inventory/delete-comment/${commentId}/`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.ok;
  } catch (err) {
    console.error("Error deleting comment:", err);
    return false;
  }
};

export { NewCommentModal, deleteComment };
